import UserCard from "./UserCard";
import {Col, Row} from "antd";
import {LinearProgress} from "@material-ui/core";
import {useMemo, useState} from "react";
import EditUser from "./EditUser";
import useUserList from "../../../shared/functions/useUserList";
import {TextField} from "@mui/material";
import {isEmpty} from "lodash";

export const filterList = (list, keyword) => {
    return list.filter(one => {
        const _keyword = keyword?.trim()?.toLowerCase();
        const _email = one?.email?.trim()?.toLowerCase();
        const _name = one?.displayName?.trim()?.toLowerCase();

        if (isEmpty(_keyword)) return true;

        return _name?.includes(_keyword) || _email?.includes(_keyword)
    })
}

export default function UserListTable() {
    const {users, isLoading, refresh} = useUserList();
    const [open, setOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [keyword, setKeyword] = useState('');
    const filtered = useMemo(() => filterList(users, keyword), [users, keyword])

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedUser(null)
    };

    const handleSelection = (user) => { 
        setSelectedUser(user)
        handleOpen()
    }

    return (
        <section style={{marginTop: 20}}>

            <TextField
                fullWidth
                label={'Rechercher par mom, email...'}
                style={{width: 500, marginLeft: 10, marginBottom: 40, marginTop: 50}}
                value={keyword}
                onChange={({target: {value}}) => setKeyword(value)}
            />

            <Row>
                {
                    filtered.map(user => (
                        <Col key={user?.id} onClick={() => handleSelection(user)}>
                            <UserCard user={user}/>
                        </Col>
                    ))
                }
            </Row>

            {
                isLoading && (
                    <LinearProgress/>
                )
            }

            {
                selectedUser && (
                    <EditUser open={open} onClose={handleClose} user={selectedUser} onRefresh={refresh}/>
                )
            }


        </section>
    )
}